import loadable from '@loadable/component';

export const EnableSmsOnSavePrompt = loadable(
    /* #__LOADABLE__ */
    () => import('./EnableSmsOnSavePrompt'),
    {
        resolveComponent: (components) => components.EnableSmsOnSavePrompt,
        ssr: false,
    }
);
